import { supportChat } from "../data/chat";
import dayjs from "dayjs";
import {
  createContext,
  useState,
  useContext,
  useCallback,
  useEffect,
} from "react";

export const ChatWidgetContext = createContext({});

const ChatWidgetProvider = ({ children }) => {
  const [isOpenChat, setIsOpenChat] = useState(false);
  const [conversation, setConversation] = useState(supportChat);

  useEffect(() => {
    if (isOpenChat && conversation.messages.length === 0) {
      const timer = setTimeout(() => {
        const welcomeMessageObj = {
          id: "welcome-message",
          type: "reply",
          time: dayjs().format("HH:mm"),
          readAt: null,
          message:
            "<p>Здравствуйте! Я помощник по обслуживанию абонентов Телекарты и Орион Экспресс. Задайте вопрос, и я постараюсь Вам помочь.</p>",
        };

        setConversation((prev) => {
          if (prev.messages.length > 0) return prev;

          return {
            ...prev,
            messages: [welcomeMessageObj],
          };
        });
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [isOpenChat, conversation.messages.length]);

  const sentMessage = useCallback(
    async ({ message, attachments }) => {
      const userMessageObj = {
        id: Date.now(),
        type: "sent",
        time: dayjs().format("HH:mm"),
        readAt: null,
        message,
        attachments,
      };

      const currentMessages = conversation.messages || [];

      const formattedHistory = currentMessages.slice(-10).map((msg) => ({
        role: msg.type === "sent" ? "user" : "assistant",
        content: msg.message,
      }));

      const requestBody = {
        message: message,
        history: formattedHistory,
      };

      setConversation((prev) => ({
        ...prev,
        messages: [...prev.messages, userMessageObj],
      }));

      getBotResponse(requestBody);
    },
    [conversation],
  );

  const getBotResponse = async (requestBody) => {
    try {
      const response = await fetch("https://srv-bot.telekarta.tv/chat", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`Status: ${response.status}`);
      }

      const result = await response.json();
      const botText = result.reply;

      if (botText) {
        const botMessageObj = {
          id: Date.now(),
          type: "reply",
          time: dayjs().format("HH:mm"),
          readAt: null,
          message: botText,
        };

        setConversation((prev) => ({
          ...prev,
          messages: [...prev.messages, botMessageObj],
        }));
      }
    } catch (error) {
      console.error("Ошибка:", error);
    }
  };

  return (
    <ChatWidgetContext.Provider
      value={{
        conversation,
        setConversation,
        isOpenChat,
        setIsOpenChat,
        sentMessage,
      }}
    >
      {children}
    </ChatWidgetContext.Provider>
  );
};

export const useChatWidgetContext = () => useContext(ChatWidgetContext);

export default ChatWidgetProvider;
